export default class NavBar {

  constructor(overlay) {
    this.searchWrapper = document.querySelector('.search__wrapper');
    this.searchButton = document.querySelector('.search__button');
    this.searchButtonSubmit = document.querySelector('.search__button-submit');
    this.searchOverlay = document.querySelector('.search__overlay');
    this.searchInput = document.querySelector('.search__input');
    this.searchClose = document.querySelector('.search__close');
    this.navbarMore = document.querySelector('.navbar__more');
    this.navbarList = document.querySelector('.navbar__list');
    this.navigationContent = document.querySelector('.navbar__content');
    this.navigationClose = document.querySelector('.navbar__mobile-close');
    this.navigationItemAll = document.querySelectorAll('.navbar__item');
    this.overlay = overlay;
  }

  _removeClassActive() {
    [...this.navigationItemAll].map(item => {
      item.classList.remove('navbar__item--active');
    });
  }

  _addClassActiveNav(target) {
    !target.closest('.navbar__item').classList.contains('submenu')
      && (this._removeClassActive(), target.closest('.navbar__item').classList.add('navbar__item--active'));
  }

  _showSearch() {
    this.overlay.classList.add('overlay--visible');
    this.searchWrapper.classList.add('search__wrapper--visible');
    document.body.classList.add('scroll-lock');

    setTimeout(() => {
      this.searchInput.focus();
    }, 100);
  }

  _hideSearch(target) {
    (target.classList.contains('search__wrapper') || target.classList.contains('search__close'))
      && (this.overlay.classList.remove('overlay--visible'),
        this.searchWrapper.classList.remove('search__wrapper--visible'));

    document.body.classList.contains('scroll-lock')
      && document.body.classList.remove('scroll-lock');
  }

  _closeMobileMenu() {
    this.navigationContent.classList.remove('navbar__content--mobile-active');
    this.overlay.classList.remove('overlay--visible');

    document.body.classList.contains('scroll-lock')
      && document.body.classList.remove('scroll-lock');
  };

  _activeMobileMenu() {
    this.navigationContent.classList.add('navbar__content--mobile-active');
    this.overlay.classList.add('overlay--visible');

    window.innerWidth <= 1024
      && document.body.classList.add('scroll-lock');
  };

  init() {

    if (this.navbarList) {
      this.navbarList.addEventListener('click', (e) => this._addClassActiveNav(e.target));
    }

    if (this.searchButton) {
      this.searchButton.addEventListener('click', () => this._showSearch());

      this.searchInput.addEventListener('keyup', e => {
        e.preventDefault();
        e.keyCode === 13
          && this.searchButtonSubmit.click();
      });

    }

    if (this.searchWrapper) {
      this.searchClose.addEventListener('click', e => this._hideSearch(e.target));
      this.searchWrapper.addEventListener('click', e => this._hideSearch(e.target));
    }

    if (this.navbarMore) {
      this.navbarMore.addEventListener('click', () => this._activeMobileMenu());
    }

    if (this.navigationClose) {
      this.navigationClose.addEventListener('click', () => this._closeMobileMenu());
      this.overlay.addEventListener('click', () => this._closeMobileMenu());
    }

  }
}
